// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"9c87beba","463":"70d9b81c","713":"20a314fe"}[chunkId] + ".chunk.js";
};